import React, { useState } from "react";
import ServiceSelection from "../../components/ServiceSelection";
import DetailsContact from "../../components/DetailsContact";
import QuoteSummary from "../../components/QuoteSummary";
import Navbar from "../../components/navBarLanding";
import { motion } from "framer-motion";
import { useHistory } from "react-router-dom";
import Loader from "../../components/loader";
import { useTranslation } from "react-i18next";
import { saveQuotation } from "../../firebase/firebaseService";

const QuoteForm: React.FC = () => {
  const [quoteDetails, setQuoteDetails] = useState({
    service: "",
    frequency: "",
    bedrooms: 0,
    bathrooms: 0,
    insideFridge: false, // ✅ Agregamos estos valores directamente
    insideOven: false,
    insideCabinets: false,
    windows: false,
    location: "",
    contactDetails: {
      name: "",
      email: "",
      phone: "",
      address: "",
    },
    price: 0,
  });

  const history = useHistory();

  const [currentStep, setCurrentStep] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isModalConfirmOpen, setIsModalConfirmOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  const { t, i18n } = useTranslation();

  // Validación para pasar al siguiente paso
  const validateStep = () => {
    if (currentStep === 0) {
      const { service, frequency, bedrooms, bathrooms } = quoteDetails;
      if (!service || !frequency || bedrooms === 0 || bathrooms === 0) {
        alert("Please complete all fields before continuing.");
        return false;
      }
    }
    return true;
  };

  const handleNext = () => {
    if (validateStep()) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  // Función para enviar el correo con contacto
  const sendEmailNotificationContact = async () => {
    setLoading(true);
    try {
      // Guardar en Firestore
      await saveQuotation({
        name: quoteDetails.contactDetails.name,
        email: quoteDetails.contactDetails.email,
        phone: quoteDetails.contactDetails.phone,
        address: quoteDetails.contactDetails.address,
        service: quoteDetails.service,
        frequency: quoteDetails.frequency,
        bedrooms: quoteDetails.bedrooms,
        bathrooms: quoteDetails.bathrooms,
        insideOven: quoteDetails.insideOven,
        insideFridge: quoteDetails.insideFridge,
        insideCabinets: quoteDetails.insideCabinets,
        windows: quoteDetails.windows,
        price: quoteDetails.price,
        wantsContact: true,
        status: "pending"
      });

      // Enviar email
      const response = await fetch(
        "https://sendemail-b7gxeb4wpq-uc.a.run.app",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            to: "gobiescs@gmail.com", // O envíalo a la empresa o usuario
            subject: "Nueva Solicitud de Cotización",
            text: `
            Nombre: ${quoteDetails.contactDetails.name}
            Email: ${quoteDetails.contactDetails.email}
            Teléfono: ${quoteDetails.contactDetails.phone}
            Dirección: ${quoteDetails.contactDetails.address}
            Servicio: ${quoteDetails.service}
            Frecuencia: ${quoteDetails.frequency}
            Habitaciones: ${quoteDetails.bedrooms}
            Baños: ${quoteDetails.bathrooms}
            insideOven: ${quoteDetails.insideOven}
            insideFridge: ${quoteDetails.insideFridge}
            insideCabinets: ${quoteDetails.insideCabinets}
            windows: ${quoteDetails.windows}
            Precio estimado: $${quoteDetails.price}
            Contacto: "EL USUARIO QUIERE SER CONTACTADO",
          `,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error del servidor:", errorData);
        throw new Error(`Error enviando el correo: ${JSON.stringify(errorData)}`);
      }
      console.log("Correo enviado exitosamente y cotización guardada");
      setLoading(false);
    } catch (error) {
      console.error("Error al enviar el correo:", error);
      setLoading(false);
    }
  };

  // Función para enviar el correo sin contacto
  const sendEmailNotificationNoContact = async () => {
    setLoading(true);
    try {
      // Guardar en Firestore
      await saveQuotation({
        name: quoteDetails.contactDetails.name,
        email: quoteDetails.contactDetails.email,
        phone: quoteDetails.contactDetails.phone,
        address: quoteDetails.contactDetails.address,
        service: quoteDetails.service,
        frequency: quoteDetails.frequency,
        bedrooms: quoteDetails.bedrooms,
        bathrooms: quoteDetails.bathrooms,
        insideOven: quoteDetails.insideOven,
        insideFridge: quoteDetails.insideFridge,
        insideCabinets: quoteDetails.insideCabinets,
        windows: quoteDetails.windows,
        price: quoteDetails.price,
        wantsContact: false,
        status: "pending"
      });

      // Enviar email
      const response = await fetch(
        "https://sendemail-b7gxeb4wpq-uc.a.run.app",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            to: "gobiescs@gmail.com", // O envíalo a la empresa o usuario
            subject: "Nueva Solicitud de Cotización",
            text: `
            Nombre: ${quoteDetails.contactDetails.name}
            Email: ${quoteDetails.contactDetails.email}
            Teléfono: ${quoteDetails.contactDetails.phone}
            Dirección: ${quoteDetails.contactDetails.address}
            Servicio: ${quoteDetails.service}
            Frecuencia: ${quoteDetails.frequency}
            Habitaciones: ${quoteDetails.bedrooms}
            Baños: ${quoteDetails.bathrooms}
            insideOven: ${quoteDetails.insideOven}
            insideFridge: ${quoteDetails.insideFridge}
            insideCabinets: ${quoteDetails.insideCabinets}
            windows: ${quoteDetails.windows}
            Precio estimado: $${quoteDetails.price}
            Contacto: "El usuario no quiere ser contactado",
          `,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Error enviando el correo");
        setLoading(false);
      }

      console.log("Correo enviado exitosamente y cotización guardada");
      setLoading(false);
    } catch (error) {
      console.error("Error al enviar el correo:", error);
      setLoading(false);
    }
  };

  const validateEmail = (email: string) => {
    const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleNextStep = () => {
    if (!validateEmail(quoteDetails.contactDetails.email)) {
      setError("Por favor, ingrese un correo válido.");
      alert("Debe ingresar un email valido");
      return;
    }
    if (!quoteDetails.contactDetails.name  || !quoteDetails.contactDetails.phone)  {
      setError("Por favor, Debe ingresar toda la información.");
      alert("Debe ingresar toda la información");
      return;
    }

    setError(""); // Si es válido, limpia el error y abre el modal

    //este modal lo abrimos mas abajo
    setIsModalConfirmOpen(true);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />

      {/* Loader - Ocupa toda la pantalla y aparece encima de todo */}
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <Loader />
        </div>
      )}

      <div className="flex-1 flex items-center justify-center px-4 md:px-10 lg:px-28 py-6 mt-12">
        <div className="flex flex-col lg:flex-row gap-8 items-start justify-center w-full">
          <div className="flex-1 relative rounded-lg border border-gray-300 overflow-hidden w-full">
            <div
              className={`transition-transform duration-500 ${
                currentStep === 0 ? "translate-x-0" : "-translate-x-full"
              }`}
            >
              <ServiceSelection setQuoteDetails={setQuoteDetails} />
              <div className="w-full flex items-center lg:justify-end justify-center mt-1 mb-4 lg:mb-0 lg:mt-14">
                <button
                  onClick={handleNext}
                  className="relative lg:absolute lg:bottom-6 lg:right-6 bg-bgPrimary text-white px-6 md:px-8 py-2 rounded-lg hover:bg-bgSecundary transition duration-300 text-sm md:text-base"
                >
                  {t("Quotepage.next")}
                </button>
              </div>
            </div>

            <div
              className={`transition-transform duration-500 absolute inset-0 ${
                currentStep === 1 ? "translate-x-0" : "translate-x-full"
              }`}
            >
              <DetailsContact
                setQuoteDetails={setQuoteDetails}
                quoteDetails={quoteDetails}
              />
              <div className="absolute bottom-6 right-6 flex items-center justify-end gap-4 md:gap-8">
                <button
                  onClick={handleBack}
                  className="border border-gray-400 text-gray-600 px-4 md:px-6 py-2 rounded-lg hover:bg-gray-100 transition duration-300 font-semibold text-sm md:text-base"
                >
                  {t("Quotepage.back")}
                </button>

                <button
                  // Aquí debemos enviar toda la información al backend
                  onClick={handleNextStep}
                  className="bg-bgPrimary text-white px-6 md:px-8 py-2 rounded-lg hover:bg-bgSecundary transition duration-300 text-sm md:text-base"
                >
                  {t("Quotepage.next")}
                </button>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/3 h-full p-4 md:p-6 rounded-lg bg-gray-100">
            <QuoteSummary
              quoteDetails={{
                name: quoteDetails.contactDetails.name,
                email: quoteDetails.contactDetails.email,
                phone: quoteDetails.contactDetails.phone,
                service: quoteDetails.service,
                frequency: quoteDetails.frequency,
                bedrooms: quoteDetails.bedrooms,
                location: quoteDetails.location,
                bathrooms: quoteDetails.bathrooms,
                insideFridge: quoteDetails.insideFridge, // ✅ PASA EL VALOR REAL
                insideOven: quoteDetails.insideOven,
                insideCabinets: quoteDetails.insideCabinets,
                windows: quoteDetails.windows,
                price: quoteDetails.price,
              }}
            />
          </div>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <motion.div
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -100, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="xl:w-[700px] w-full"
          >
            <div className="bg-white p-8 rounded-md shadow-lg w-full">
              <h2 className="text-[22px] font-semibold mb-12 text-center text-textTitle">
                {t("Quotepage.thank")}
              </h2>
              <p className="text-[12px] font-medium mb-12 text-center text-textTipic">
                {t("Quotepage.thank description")}
              </p>

              <p className="text-[12px] font-medium mb-12 text-left text-textTipic">
                {t("Quotepage.what")}
              </p>
              <div className="flex justify-between items-center">
                <button
                  onClick={async () => {
                    await sendEmailNotificationContact(); // Enviar el correo
                    history.push("/"); // Redirigir al home
                  }}
                  type="submit"
                  className="bg-bgPrimary text-white px-4 py-2 rounded-md w-[240px] font-semibold"
                  disabled={loading}
                >
                  {t("Quotepage.iwwant")}
                </button>

                <button
                  onClick={async () => {
                    await sendEmailNotificationNoContact(); // Enviar el correo
                    history.push("/"); // Redirigir al home
                  }}
                  type="submit"
                  disabled={loading}
                  className="bg-white border-2 border-bgPrimary text-textPrimary px-4 py-2 rounded-md w-[250px] font-semibold"
                >
                  {t("Quotepage.ionly")}
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}

      {/* Modal */}
      {isModalConfirmOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-4">
    <motion.div
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -100, opacity: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="xl:w-[900px] w-full max-w-[90vw] max-h-[90vh] overflow-y-auto bg-white p-8 rounded-md shadow-lg"
    >
      <h2 className="text-[22px] font-semibold mb-6 text-center text-textTitle">
      {t("Quotepage.hello")} {quoteDetails.contactDetails.name}, {t("Quotepage.descriptionmodal")}
      </h2>
      <h2 className="text-[12px] font-semibold mb-4 text-center text-textTipic">
      {t("Quotepage.Servicemodal")} {quoteDetails.service}
      </h2>

      <p className="text-[12px] font-medium mb-6 text-left text-textTipic">
      {t("Quotepage.subtitlemodal")}
      </p>

      <h2 className="text-[12px] font-semibold mb-4 text-left text-textTipic">{t("Quotepage.incluyemodal")}</h2>
      <p className="text-[12px] font-medium mb-6 text-left text-textTipic">
        <span className="font-semibold block">{t("Quotepage.Habitaciones")}</span> {t("Quotepage.hab_description")}
        <span className="font-semibold block">{t("Quotepage.baños")}</span> {t("Quotepage.baños_description")}
        <span className="font-semibold block">{t("Quotepage.Sala y Comedor")}</span> {t("Quotepage.sala_description")}
      </p>

      <h2 className="text-[12px] font-semibold mb-4 text-left text-textTipic">{t("Quotepage.Noincluyemodal")}</h2>
      <p className="text-[12px] font-medium mb-6 text-left text-textTipic">
      {t("Quotepage.noincluye_description")}
      </p>

      <label className="flex items-center space-x-2 mb-6">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={() => setIsChecked(!isChecked)}
          className="w-5 h-5"
        />
        <span> {t("Quotepage.acept")}</span>
      </label>

      <div className="flex justify-between items-center">

      <button
          onClick={() => {
            setIsModalOpen(true)
            setIsModalConfirmOpen(false)

          } }
          type="submit"
          className={`px-4 py-2 rounded-md w-[240px] font-semibold ${
            isChecked ? "bg-bgPrimary text-white" : "bg-gray-400 text-gray-200 cursor-not-allowed"
          }`}
          disabled={!isChecked}
        >
          {t("Quotepage.button_acept")}
        </button>

        <button
          onClick={() => {
           
            setIsModalConfirmOpen(false)

          } }
          type="submit"
          className="px-4 py-2 rounded-md w-[240px] font-semibold border border-bgPrimary text-textPrimary"
                
        >
          {t("Quotepage.button_cancel")}
        </button>
      </div>
    </motion.div>
  </div>
)}

    </div>
  );
};

export default QuoteForm;
